export const CONTROL_MODES = {
  NONE: "none",
  MOVE: "move",
  RESIZE: "resize",
  ROTATE: "rotate",
};
